import { types } from "../types/typesAuth";
import { axiosSinToken, axiosConToken } from "../helpers/axios";
import { validaMessagesErrors } from "../helpers/validates";
import {
  get_routes_and_sidernav_by_usuario_and_empleado,
  messageError,
} from "../helpers";
import { PATH_SEGURIDAD } from "../constants/routes";

export const authStartLogin = (username, password) => {
  return async (dispatch) => {
    try {
      const resp = await axiosSinToken.post(`${PATH_SEGURIDAD.auth}login/`, {
        username,
        password,
      });
      const body = resp.data;
      const { authTokens, empleado, usuario } = body;
      localStorage.setItem("authTokens", JSON.stringify(authTokens));
      dispatch(authUsuarioSetActive(usuario));
      dispatch(authEmpleadoSetActive(empleado));
      const paths = get_routes_and_sidernav_by_usuario_and_empleado(
        usuario,
        !!empleado,
      );
      dispatch(authUsuarioSetPaths(paths));
    } catch (error) {
      const resp = error?.response;

      if (resp?.status === 400) {
        messageError(resp.data.message);
      } else {
        validaMessagesErrors(error);
      }
    }
  };
};
export const authStartTokenRefreshed = () => {
  return async (dispatch) => {
    try {
      const authTokensActual = JSON.parse(localStorage.getItem("authTokens"));
      const resp = await axiosSinToken.post(
        `${PATH_SEGURIDAD.auth}token/refresh/`,
        {
          refresh: authTokensActual.refresh,
        },
      );
      const body = resp.data;
      const { authTokens } = body;
      localStorage.setItem("authTokens", JSON.stringify(authTokens));
    } catch (error) {
      const resp = error.response;
      if (resp.status === 400) {
        messageError(resp.data.message);
      } else {
        validaMessagesErrors(error);
      }
    }
  };
};
export const authStartChecking = () => {
  return async (dispatch) => {
    // iniciamos la comprobación
    dispatch(authUsuarioCheking());
    try {
      const tokens = localStorage.getItem("authTokens") || null;
      // Si no hay tokens, no hay nada que verificar
      if (tokens) {
        const resp = await axiosConToken.get(`${PATH_SEGURIDAD.auth}me/`);
        const { empleado, usuario } = resp.data;
        dispatch(authUsuarioSetActive(usuario));
        dispatch(authEmpleadoSetActive(empleado));
        const paths = get_routes_and_sidernav_by_usuario_and_empleado(
          usuario,
          !!empleado,
        );
        dispatch(authUsuarioSetPaths(paths));
      } else {
        dispatch(authLogout());
      }
    } catch (error) {
      validaMessagesErrors(error);
      dispatch(authLogout());
    } finally {
      dispatch(authUsuarioCheking(false));
    }
  };
};

export const authStartLogout = () => {
  return async (dispatch) => {
    try {
      await axiosConToken.post(`${PATH_SEGURIDAD.auth}logout/`);
      localStorage.clear();
    } catch (error) {
      validaMessagesErrors(error);
    } finally {
      dispatch(authLogout());
    }
  };
};
const authUsuarioSetActive = (user) => ({
  type: types.authUsuarioLoginSetActive,
  payload: user,
});
const authUsuarioSetPaths = (paths = []) => ({
  type: types.authUsuarioSetPaths,
  payload: paths,
});

const authUsuarioCheking = (cheking = true) => ({
  type: types.authUsuarioChecking,
  payload: cheking,
});

const authLogout = () => ({
  type: types.authUsuarioLogout,
});

const authEmpleadoSetActive = (empleado) => ({
  type: types.authEmpleadoSetActive,
  payload: empleado,
});
